export const AGENT_EXTENSION_ID = 'npclhjbddhklpbnacpjloidibaggcgon';
export const AGENT_EXTENSION_MAIN_PORT_NAME = 'entropy-agent-extension-main';
export const MCP_SERVER_NAME_SEPARATOR = '__';
export const AGENT_OVERLAY_PREFIX = `pplx-agent-`;
export const VISIBLE_AGENT_OVERLAY_STOP_BUTTON_ID = `${AGENT_OVERLAY_PREFIX}0_0-overlay-stop-button`;
// Initially this will be used only by Luna for voice mode and later native sidecar, etc.
// The goal is to reuse agent extension logic, but use it not from web interfaces like sidecar,
// and voice floating window, but from native interface.
export const BROWSER_NATIVE_PORT_NAME = 'comet-agent-client';
export const GOOGLE_DOCS_SIMPLIFIED_PATHNAME_SUFFIX = '/mobilebasic';
//# sourceMappingURL=consts.js.map